import Text from "./Text";
import Button from "./Buttons/Button";

const CookieInfo = ({ onAccept }) => {
  return (
    <div className="flex flex-col gap-4 max-w-md">
      <Text type="webtitle">Cookies & Datenschutz</Text>

      <Text classNames="text-gray-600">
        Cashier One verwendet Cookies, um grundlegende Funktionen wie Anmeldung,
        Sicherheit und Sitzungsverwaltung bereitzustellen.
      </Text>

      <Text classNames="text-gray-600">
        Es werden keine Tracking- oder Marketing-Cookies eingesetzt.
        Weitere Informationen findest du in unserer Datenschutzerklärung.
      </Text>

      <div className="flex justify-end gap-3 mt-4">
        <Button
          buttonColor="bg-blue-600 hover:bg-blue-700 w-full"
          onClickAction={onAccept}
        >
          <Text classNames="text-white">Verstanden</Text>
        </Button>
      </div>
    </div>
  );
};

export default CookieInfo;
